import { render } from "./SearchMenu.vue?vue&type=template&id=5478875a&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"

import "./SearchMenu.vue?vue&type=style&index=0&id=5478875a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5478875a"]])

export default __exports__